/**
 * Labstep
 *
 * @module components/Resource/Info/Preview
 * @desc Preview for resource
 */

import { MetadataPreview as MetadataListPreview } from 'labstep-web/components/Metadata/Preview';
import { ResourcePreviewManager as ResourcePreview } from 'labstep-web/components/Resource/Preview';
import { Flex } from 'labstep-web/core/Flex';
import type React from 'react';
import styles from './styles.module.scss';
import type { IResourceInfoPreviewProps } from './types';

export const ResourceInfoPreview: React.FC<
  IResourceInfoPreviewProps
> = ({ resource, showMetadata, showIcon }) => (
  <Flex grow={1} column>
    <div className={styles.info}>
      <ResourcePreview resource={resource} showIcon={showIcon} />
      {showMetadata && resource.metadata_thread && (
        <MetadataListPreview entity={resource} withIcon />
      )}
    </div>
  </Flex>
);
